import { render } from "./ModalAddCard.vue?vue&type=template&id=74ca153f&scoped=true"
import script from "./ModalAddCard.vue?vue&type=script&lang=js"
export * from "./ModalAddCard.vue?vue&type=script&lang=js"

import "./ModalAddCard.vue?vue&type=style&index=0&id=74ca153f&lang=scss&scoped=true"

import exportComponent from "/home/runner/work/treedots/treedots/apps/frontend-b2b/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-74ca153f"]])

export default __exports__